module.exports = __webpack_public_path__ + "static/media/ui.d2ea4fef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/ui.svg
// module id = 195
// module chunks = 0